import dynamic from 'next/dynamic';
import React from 'react';

const ComponentList = dynamic(
  () => import('@uikit/components/ComponentList/ComponentList')
);
const Container = dynamic(
  () => import('@uikit/components/Container/Container')
);
const ESolFooter = dynamic(
  () => import('@uikit/components/ESolFooter/ESolFooter')
);
const ESolHeader = dynamic(
  () => import('@uikit/components/ESolHeader/ESolHeader')
);
const Headline = dynamic(() => import('@uikit/components/Headline/Headline'));
const IframeSection = dynamic(
  () => import('@uikit/components/IframeSection/IframeSection')
);
const ImageGallery = dynamic(
  () => import('@uikit/components/ImageGallery/ImageGallery')
);
const Modal = dynamic(() => import('@uikit/components/Modal/Modal'));
const Section = dynamic(() => import('@uikit/components/Section/Section'));
const SectionVisual = dynamic(
  () => import('@uikit/components/SectionVisual/SectionVisual')
);
const StageBoxText = dynamic(
  () => import('@uikit/components/StageBoxText/StageBoxText')
);
const TeaserWithImage = dynamic(
  () => import('@uikit/components/TeaserWithImage/TeaserWithImage')
);
const TwoColumnContainer = dynamic(
  () => import('@uikit/components/TwoColumnContainer/TwoColumnContainer')
);
const HeroArea = dynamic(() => import('@uikit/composites/HeroArea/HeroArea'));
const HeroAreaContent = dynamic(
  () => import('@uikit/composites/HeroArea/HeroAreaContent')
);
const SmallHeroArea = dynamic(
  () => import('@uikit/composites/SmallHeroArea/SmallHeroArea')
);
const Forms = dynamic(() => import('../components/Forms/Forms'), {
  ssr: false,
});

export const CmsComponentsESol = {
  'esol-footer': ESolFooter,
  'esol-header': ESolHeader,
  'esol-stage-box-text': StageBoxText,
  'esol-section': Section,
  'esol-container': Container,
  'esol-stage-small': SmallHeroArea,
  'esol-hero-area-content': HeroAreaContent,
  'esol-stage': HeroArea,
  'esol-headline': Headline,
  'esol-stage-area': React.Fragment,
  'esol-section-visual': SectionVisual,
  'esol-two-column-container': TwoColumnContainer,
  'esol-modal': Modal,
  'esol-iframe-section': IframeSection,
  'esol-image-gallery': ImageGallery,
  'esol-download-area': React.Fragment,
  'esol-contact-area': React.Fragment,
  'esol-component-list': ComponentList,
  'esol-forms': Forms,
  'esol-teaser-with-image': TeaserWithImage,
};
